"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionsWithStates = exports.subscriptionState = void 0;
var _dateTime = require("./dateTime.js");
var subscriptionState = function subscriptionState(subscription) {
  // adding 1 second to servertime for negligible time diff

  if (subscription.get('activation_date', 0) && subscription.get('activation_date', 0) > (0, _dateTime.getServerTimeNow)() + 1000) return 'delayed';
  if (!subscription.get('infinite') && subscription.get('expiry_date', 0) < (0, _dateTime.getServerTimeNow)() - 1000) return 'expired';
  return 'active';
};
exports.subscriptionState = subscriptionState;
var subscriptionsWithStates = function subscriptionsWithStates(subscriptions) {
  return subscriptions.map(function (subscription) {
    var state = subscriptionState(subscription);
    return subscription.merge({
      delayed: state === 'delayed',
      expired: state === 'expired',
      active: state === 'active'
    });
  });
};
exports.subscriptionsWithStates = subscriptionsWithStates;